import { PaymentMethod } from "./enums";

export function formatPaymentMethod(method: PaymentMethod): string {
  switch (method) {
    case PaymentMethod.Check:
      return "Check";
    case PaymentMethod.Cash:
      return "Cash";
    case PaymentMethod.Zelle:
      return "Zelle";
    case PaymentMethod.CreditCard:
      return "Credit Card";
  }
}
